import React from 'react';

const SelfExcludedBrandsList: React.FC = () => (
  <ul>
    <li>PokerStars</li>
    <li>Paddy Power</li>
    <li>Betfair</li>
    <li>Sky Betting & Gaming</li>
    <li>Tombola</li>
  </ul>
);

export default SelfExcludedBrandsList;
